import React, { Component } from "react";
import Header from "./Header";
import Contact from "./Contact";
import Footer from "./Footer";

import ReactGA from "react-ga";
import $ from "jquery";


class Home extends Component {

    constructor(props) {
        super(props);
        this.state = {
            foo: "bar",
            resumeData: {}
        };

        ReactGA.initialize("UA-110570651-1");
        ReactGA.pageview(window.location.pathname);
    }

    getResumeData() {
        $.ajax({
            url: "./resumeData.json",
            dataType: "json",
            cache: false,
            success: function (data) {
                this.setState({ resumeData: data });
            }.bind(this),
            error: function (xhr, status, err) {
                console.log(err);
                // alert(err);
            }
        });
    }

    componentDidMount() {
        this.getResumeData();
    }

    render() {
        if (!this.props.data) return null;

        return (
            <div className="home">

                <Header data={this.state.resumeData.main} />
                <section className="community-message">
                    <div className="row">
                        <p>Refresh Connections is no longer available.</p>
                        <p>Thank you for being part of this community. Stay safe, and keep masking and taking care of one another.</p>
                    </div>
                </section>
                <Contact />
                <Footer data={this.state.resumeData.main} />
            </div>)
    }
}

export default Home;
